module.exports = __webpack_public_path__ + "media/img/frontend_application/promo-banner-md-a43b706998de6fe7b3951f54cdfd112d.png";